export default "__VITE_ASSET__070ce29e__"